<template>
    <div id="container">
        <router-view />
    </div>
</template>
<script>
export default {
    name: 'dynamicNews'
}
</script>
<style scoped>

</style>

